/**
 * Shared category decision model used by JS + native payload sync.
 * Local-only metadata; no user activity or browsing history.
 */

export const CATEGORY_NAMES = ["Adult", "Gambling", "Social Media", "Gaming"];

export const DEFAULT_CATEGORY_RULES = {
  Adult: "block",
  Gambling: "ignore",
  "Social Media": "ignore",
  Gaming: "ignore",
};

export const CATEGORY_DOMAIN_RULES = {
  Adult: ["pornhub.com", "xvideos.com", "xnxx.com", "redtube.com", "youporn.com", "onlyfans.com"],
  Gambling: ["bet365.com", "draftkings.com", "fanduel.com", "pokerstars.com", "stake.com", "betfair.com"],
  "Social Media": [
    "facebook.com",
    "instagram.com",
    "tiktok.com",
    "x.com",
    "twitter.com",
    "snapchat.com",
    "reddit.com",
    "threads.net",
  ],
  Gaming: ["twitch.tv", "steamcommunity.com", "steampowered.com", "epicgames.com", "roblox.com", "discord.com"],
};

export const CATEGORY_KEYWORD_RULES = {
  // Keep specific — bare "sex" / "bet" cause too many false positives.
  Adult: ["porn", "xxx", "pornhub", "xvideos", "xnxx", "hentai", "nsfw", "onlyfans", "redtube", "youporn"],
  Gambling: ["casino", "pokerstars", "sportsbook", "bet365", "draftkings", "fanduel"],
  "Social Media": ["facebook", "instagram", "tiktok", "snapchat", "threads.net"],
  Gaming: ["steampowered", "epicgames", "roblox", "playstation"],
};

export function normalizeCategoryRuleValue(v) {
  const x = String(v || "").trim().toLowerCase();
  if (x === "allow") return "allow";
  if (x === "block") return "block";
  return "ignore";
}

export function normalizeCategoryRules(input) {
  const inObj = input && typeof input === "object" ? input : {};
  const out = {};
  for (const name of CATEGORY_NAMES) {
    const fallback = DEFAULT_CATEGORY_RULES[name] || "ignore";
    out[name] = normalizeCategoryRuleValue(inObj[name] ?? fallback);
  }
  return out;
}

export function getCategoryModelForNative() {
  return {
    categories: CATEGORY_NAMES,
    domainRules: CATEGORY_DOMAIN_RULES,
    keywordRules: CATEGORY_KEYWORD_RULES,
    precedence: ["category", "allowlist", "keyword", "blocklist"],
  };
}

export function resolveCategoryFromHost(host, { domainMatches } = {}) {
  const matches = typeof domainMatches === "function" ? domainMatches : (a, b) => a === b || a.endsWith(`.${b}`);

  if (!host) return null;

  for (const category of CATEGORY_NAMES) {
    const domains = CATEGORY_DOMAIN_RULES[category] || [];
    for (const d of domains) {
      if (matches(host, d)) return category;
    }
  }

  for (const category of CATEGORY_NAMES) {
    const kws = CATEGORY_KEYWORD_RULES[category] || [];
    for (const kw of kws) {
      if (kw && host.includes(kw)) return category;
    }
  }
  return null;
}

